import React, { useEffect, useState, useRef } from 'react';
import { useBranchContext } from '../../components/Context/BranchContext';
import { useSnackbar } from '../SnackBar';
import { usePartnerContext } from '../../components/Context/PartnerContext';
import { useNavigate } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const EmployeeDetailsView = () => {
    const styles = { inputDisabled: { border: 'none', background: 'none' } };
    const { updatedembployee, deleteEmployee } = usePartnerContext();
    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const handelEdit = () => {
        navigate(`/editemployee/${updatedembployee[0].id}/true`, { state: { Updateemployee: updatedembployee } });
    };

    const [confirmOpen, setConfirmOpen] = useState(false);

    const handleDeleteClick = () => {
        setConfirmOpen(true); // Open the confirmation dialog
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false); // Close the confirmation dialog
    };
    const handleConfirmDelete = async () => {
        setConfirmOpen(false); // Close the confirmation dialog
        if (updatedembployee && updatedembployee.length > 0) {
            try {

                await deleteEmployee(updatedembployee[0].id); // Call delete action
                showSnackbar("Employee deleted successfully", "success");
                navigate('/allemployee'); // Redirect after deletion
            } catch (error) {
                showSnackbar("Failed to delete employee", "error");
            }
        }
    };

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/allemployee">Home</a></li>
                        <li className="breadcrumb-item"><a href="/allemployee">Employees</a></li>
                        <li className="breadcrumb-item active"><a href="/employeeadd">New Employee</a></li>
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Employee Details</h5>
                                <div>
                                    <form>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Name</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={styles.inputDisabled}
                                                    defaultValue={updatedembployee[0]?.name || ''}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Email</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={styles.inputDisabled}
                                                    defaultValue={updatedembployee[0]?.email || ''}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Phone</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={styles.inputDisabled}
                                                    defaultValue={updatedembployee[0]?.phone || ''}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Specialization</label>
                                            <div className="col-sm-6">
                                                <ul
                                                    className="form-control"
                                                    style={styles.inputDisabled}
                                                    disabled
                                                >
                                                    {updatedembployee[0]?.specialization.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Position</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={styles.inputDisabled}
                                                    defaultValue={updatedembployee[0]?.position || ''}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Branch</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                     disabled
                                                    style={styles.inputDisabled}
                                                    defaultValue={updatedembployee[0]?.branchName || ''}
                                                    
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{ position: 'relative' }}>
                                            <div className="col-12 text-center">
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleDeleteClick}
                                                    className="me-3" style={{
                                                        position: 'absolute', backgroundColor: '#02176D', color: 'white',
                                                        bottom: '350px', // Adjust distance from the bottom
                                                        right: '10px', 
                                                        textTransform: 'none' // Adjust distance from the right
                                                    }}
                                                >
                                                    Delete Employee
                                                </Button>

                                                {/* Confirmation Dialog */}
                                                <Dialog
                                                    open={confirmOpen}
                                                    onClose={handleConfirmClose}
                                                >
                                                    <DialogTitle>Confirm Deletion</DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText>
                                                            Are you sure you want to delete this employee? This action cannot be undone.
                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button onClick={handleConfirmClose} color="secondary">
                                                            Cancel
                                                        </Button>
                                                        <Button onClick={handleConfirmDelete} color="primary" autoFocus>
                                                            Confirm
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog><div className="row" style={{ position: 'relative' }}>
                                            <div className="col-12 text-center">
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handelEdit}
                                                    className="me-3" style={{
                                                        position: 'absolute', backgroundColor: '#02176D', color: 'white',
                                                        bottom: '350px', // Adjust distance from the bottom
                                                        right: '170px', 
                                                        textTransform: 'none' // Adjust distance from the right
                                                    }}
                                                >
                                                    Edit
                                                </Button>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default EmployeeDetailsView;
